{
  "breadcrumb": {
    "root": "BLIKS IO",
    "dashboard": "Munkakörnyezetem",
    "recordingDashboard": "Felvételi vezérlőpult",
    "organization": "Szervezeti katalógusok",
    "organigram": "Organigram",
    "processes": "Folyamatok",
    "departments": "Osztályok",
    "myOrgFunctions": "Funkcióim",
    "functions": "Funkciók",
    "teams": "Csapatok",
    "systems": "Rendszerek",
    "externalContacts": "Külső kapcsolatok",
    "artifacts": "Dokumentumok",
    "orgMembers": "Személyek",
    "allProcesses": "Összes folyamat",
    "processEditor": "Folyamatszerkesztő",
    "myTasks": "Feladataim",
    "organizationSettings": "Beállítások",
    "dataSync": "Adatszinkronizálás",
    "initialSetup": "Kezdeti beállítás",
    "setupPending": "Beállítás folyamatban",
    "seatOverrun": "Szervezet zárolva",
    "processMap": "Folyamattérkép",
    "processChains": "Folyamatláncok",
    "systemLandscape": "Rendszertájkép",
    "admin": "Admin",
    "tenants": "Bérlők",
    "accounts": "Fiókok",
    "users": "Felhasználók",
    "partnerContent": "Partnertartalmak",
    "createProcesses": "Folyamatok létrehozása",
    "shadowSystems": "Árnyékrendszerek",
    "departmentsBulkUpload": "Osztályok tömeges feltöltése",
    "userManagement": "Felhasználókezelés",
    "apps": "Alkalmazások",
    "auditLogs": "Auditnapló",
    "recordingAnalytics": "Felvételi elemzések",
    "aiUsage": "MI-használat",
    "partner": "Partner",
    "leads": "Leadek",
    "tasks": "Feladatok",
    "helpCenter": "Ügyfélszolgálat",
    "supportTickets": "Support jegyek"
  },
  "notifications": {
    "title": "Értesítések",
    "empty": "Nincsenek értesítések"
  }
}
